import React from 'react';
import { useTranslation } from 'react-i18next';
import SeoMeta from '../components/SeoMeta';
import { dpaTranslations } from '../i18n/dpa-translations';

const DPAPage = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'es';
  const t = (key) => dpaTranslations[lang][key] || dpaTranslations['es'][key] || key;

  return (
    <>
      <SeoMeta
        title={t('page-title')}
        description={t('page-description')}
      />

      <div className="bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">
              {t('title')}
            </h1>

            <p className="text-sm text-gray-600 mb-8">
              {t('last-updated')}
            </p>

            {/* 1. Objeto y Duración */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-1-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-1-p1')}</p>
              <p className="text-gray-700 mb-4">{t('section-1-p2')}</p>
              <p className="text-gray-700">{t('section-1-p3')}</p>
            </section>

            {/* 2. Naturaleza y Finalidad */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-2-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-2-p1')}</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li>{t('section-2-item-1')}</li>
                <li>{t('section-2-item-2')}</li>
                <li>{t('section-2-item-3')}</li>
                <li>{t('section-2-item-4')}</li>
              </ul>
              <p className="text-gray-700">{t('section-2-p2')}</p>
            </section>

            {/* 3. Tipos de Datos Personales */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-3-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-3-p1')}</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li>{t('section-3-item-1')}</li>
                <li>{t('section-3-item-2')}</li>
                <li>{t('section-3-item-3')}</li>
                <li>{t('section-3-item-4')}</li>
              </ul>
              <p className="text-gray-700">{t('section-3-p2')}</p>
            </section>

            {/* 4. Categorías de Interesados */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-4-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-4-p1')}</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li>{t('section-4-item-1')}</li>
                <li>{t('section-4-item-2')}</li>
                <li>{t('section-4-item-3')}</li>
                <li>{t('section-4-item-4')}</li>
              </ul>
            </section>

            {/* 5. Obligaciones del Encargado */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-5-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-5-p1')}</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li>{t('section-5-item-1')}</li>
                <li>{t('section-5-item-2')}</li>
                <li>{t('section-5-item-3')}</li>
                <li>{t('section-5-item-4')}</li>
                <li>{t('section-5-item-5')}</li>
                <li>{t('section-5-item-6')}</li>
                <li>{t('section-5-item-7')}</li>
              </ul>
            </section>

            {/* 6. Derechos del Responsable */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-6-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-6-p1')}</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li>{t('section-6-item-1')}</li>
                <li>{t('section-6-item-2')}</li>
                <li>{t('section-6-item-3')}</li>
              </ul>
            </section>

            {/* 7. Subencargados */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-7-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-7-p1')}</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li>
                  <strong>{t('section-7-sub-1-name')}</strong>: {t('section-7-sub-1-detail')}
                </li>
                <li>
                  <strong>{t('section-7-sub-2-name')}</strong>: {t('section-7-sub-2-detail')}
                </li>
                <li>
                  <strong>{t('section-7-sub-3-name')}</strong>: {t('section-7-sub-3-detail')}
                </li>
                <li>
                  <strong>{t('section-7-sub-4-name')}</strong>: {t('section-7-sub-4-detail')}
                </li>
                <li>
                  <strong>{t('section-7-sub-5-name')}</strong>: {t('section-7-sub-5-detail')}
                </li>
              </ul>
              <p className="text-gray-700">{t('section-7-p2')}</p>
            </section>

            {/* 8. eFTI: Acceso de Autoridades Competentes */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-8-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-8-p1')}</p>
              <p className="text-gray-700 mb-4">{t('section-8-p2')}</p>
              <p className="text-gray-700 mb-4">{t('section-8-p3')}</p>
              <p className="text-gray-700">{t('section-8-p4')}</p>
            </section>

            {/* 9. eFTI: Operations Log */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-9-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-9-p1')}</p>
              <p className="text-gray-700">{t('section-9-p2')}</p>
            </section>

            {/* 10. eFTI: Registro de Actividades */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('section-10-title')}
              </h2>
              <p className="text-gray-700 mb-4">{t('section-10-p1')}</p>
              <p className="text-gray-700">{t('section-10-p2')}</p>
            </section>

            {/* Footer */}
            <div className="border-t border-gray-200 pt-6 mt-8">
              <p className="text-sm text-gray-600 mb-2">{t('footer-p1')}</p>
              <p className="text-sm text-gray-600 mb-2">{t('footer-copyright')}</p>
              <p className="text-sm text-gray-600">
                {t('footer-contact')}{' '}
                <a href={`mailto:${t('footer-email')}`} className="text-blue-600 hover:underline">
                  {t('footer-email')}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DPAPage;
